import React from "react";
import { observer, inject } from "mobx-react";
import { Menu } from "antd";
import "antd/dist/antd.css";
import AddressInfo from "./AddressInfo";
//const alert = Modal.alert;
//import { FiEdit } from "react-icons/fi";

//const { SubMenu } = Menu;
@inject("cartStore")
@observer
class CocoMenu extends React.Component {
  // componentDidUpdate(prevProps) {
  //   // Check if menu selection has changed
  //   const prevKey =
  //     prevProps && prevProps.cartStore && prevProps.cartStore.menuStore
  //       ? prevProps.cartStore.menuStore.horizontalMenuSelectedIndex
  //       : null;
  //   const currentKey =
  //     this.props.cartStore && this.props.cartStore.menuStore
  //       ? this.props.cartStore.menuStore.horizontalMenuSelectedIndex
  //       : null;
  //   const prevPromoKey =
  //     prevProps && prevProps.cartStore && prevProps.cartStore.menuStore
  //       ? prevProps.cartStore.menuStore.PromoMenuKey
  //       : null;
  //   const currentPromoKey =
  //     this.props.cartStore && this.props.cartStore.menuStore
  //       ? this.props.cartStore.menuStore.PromoMenuKey
  //       : null;
  // }

  renderCocoHorizontalMenu = (data) => {
    let promolength = this.props.cartStore.menuStore.promotionsLength;
    //let promos=this.props.cartStore.menuStore.promotions;
    // Debug the selectedKeys being passed to Menu
    const currentSelectedKeys =
      this.props.cartStore.menuStore.horizontalMenuSelectedIndex;

    return (
      <Menu
        key={data.map((item) => item.name || item).join("-")}
        defaultSelectedKeys={["0"]}
        mode="horizontal "
        id={promolength > 0 ? "catgeory-horizontal" : "cocomunu-horizontal"}
        selectedKeys={currentSelectedKeys}
        className="catgeory-horizontal"
      >
        {data.map((item, index) => (
          <Menu.Item
            key={index}
            id={"submenucoco" + index}
            data-category={item}
            onClick={(obj) => {
              let key = parseInt(obj.key);
              //// console.log(5555,key);
              // //this.props.cartStore.menuStore.horizontalMenuSelectedKey = item;
              // // this.setState({selectedKey:[key.toString()]});

              const targetElement = document.getElementById(item);
              if (targetElement) {
                targetElement.scrollIntoView();
                //targetElement.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
              } else {
                console.warn(`⚠️ Could not find element with id "${item}" - it may be filtered out by search`);
              }

              this.props.cartStore.menuStore.horizontalMenuSelectedIndex = [
                key.toString(),
              ];
            }}
          >
            {item}
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  // Debug component updates to ensure reactivity is working
  componentDidUpdate(prevProps) {
    const currentSelection =
      this.props.cartStore.menuStore.horizontalMenuSelectedIndex;
    const prevSelection =
      prevProps.cartStore.menuStore.horizontalMenuSelectedIndex;
    const currentForceUpdate = this.props.cartStore.menuStore.forceMenuUpdate;
    const prevForceUpdate = prevProps.cartStore.menuStore.forceMenuUpdate;

    if (
      JSON.stringify(currentSelection) !== JSON.stringify(prevSelection) ||
      currentForceUpdate !== prevForceUpdate
    ) {
      // console.log("🎯 HORIZONTAL MENU SELECTION CHANGED:", {
      //   from: prevSelection,
      //   to: currentSelection,
      //   activeIndex: currentSelection[0] || 0,
      //   forceUpdate: currentForceUpdate,
      // });

      // Force update the menu UI state
      this.forceUpdate();
    }
  }

  // Method to programmatically trigger scrolling and centering of active menu item
  triggerActiveMenuScrolling = (data) => {
    if (!data || data.length === 0) return;

    let selectedIndex = parseInt(
      this.props.cartStore.menuStore.horizontalMenuSelectedIndex[0] || 0
    );
    let activeItem = data[selectedIndex];

    if (!activeItem) return;

    // console.log(
    //   "Triggering scroll for active menu item:",
    //   activeItem,
    //   "at index:",
    //   selectedIndex
    // );

    // Scroll to the corresponding content section
    let targetElement = document.getElementById(activeItem);
    if (targetElement) {
      // console.log("Scrolling to content section:", targetElement.id);
      targetElement.scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
      });
    } else {
      console.warn("Could not find content section for:", activeItem);
    }
  };

  // Method to trigger scrolling with delay (useful for external calls)
  triggerActiveMenuScrollingDelayed = (data, delay = 300) => {
    setTimeout(() => {
      this.triggerActiveMenuScrolling(data);
    }, delay);
  };

  renderCocoHorizontalPromos = () => {
    let promolength = this.props.cartStore.menuStore.promotionsLength;
    let data = this.props.cartStore.menuStore.promotions;
    if (promolength === 0) {
      return "";
    }
    return (
      <Menu
        //defaultOpenKeys={['0']}
        defaultSelectedKeys={["0"]}
        mode="horizontal "
        id="cocomunu-horizontal"
        selectedKeys={[this.props.cartStore.menuStore.PromoMenuKey.toString()]}
      >
        {data.map((item, index) => (
          <Menu.Item
            key={index}
            onClick={(obj) => {
              this.props.cartStore.menuStore.horizontalMenuSelectedKey = item;
              this.props.cartStore.menuStore.activePromo = index;
              this.props.cartStore.menuStore.PromoMenuKey = index;
              this.props.cartStore.menuStore.resetMeuList();
              this.props.cartStore.menuStore.searchResult =
                this.props.cartStore.menuStore.filterMenuList;

              // Set flag to temporarily disable scroll detection
              window.promoJustClicked = true;
              setTimeout(() => {
                window.promoJustClicked = false;
                // console.log("🔄 Re-enabled scroll detection after promo click");
              }, 3000); // Disable for 2 seconds

              // Scroll to first category of the selected promotion
              setTimeout(() => {
                const newHorizontalCategoryList = this.props.cartStore.menuStore.horizontalCategoryList;
                if (newHorizontalCategoryList && newHorizontalCategoryList.length > 0) {
                  const firstCategory = newHorizontalCategoryList[0];
                  const categoryElement = document.getElementById(firstCategory);
                  if (categoryElement) {
                    // console.log(`🎯 Scrolling to first category "${firstCategory}" of promo "${item}"`);
                    categoryElement.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  } else {
                    console.warn(`⚠️ Could not find element with id "${firstCategory}"`);
                  }
                } else {
                  console.warn(`⚠️ No categories found for promo "${item}"`);
                }
              }, 100);

              // Center the selected menu item
              setTimeout(() => {
                const selectedItem = document.querySelector(
                  ".ant-menu-item-selected"
                );
                if (selectedItem) {
                  selectedItem.scrollIntoView({
                    block: "center",
                    inline: "center",
                    behavior: "smooth",
                  });
                }
              }, 500);

              //this.props.cartStore.menuStore.horizontalMenuSelectedIndex=["0"];
            }}
          >
            {item}
          </Menu.Item>
        ))}
      </Menu>
    );
  };
  render() {
    let data = this.props.cartStore.menuStore.horizontalCategoryList;

    return (
      <div className="topsection">
        <AddressInfo
          page="menu"
          prelength={this.props.cartStore.menuStore.preQuestionFileds.length}
        />
        <div className="cocoMenu cocoHorizontalMenu">
          {this.renderCocoHorizontalPromos()}
          {this.renderCocoHorizontalMenu(data)}
        </div>
      </div>
    );
  }
}

export default CocoMenu;
